module.exports = __webpack_public_path__ + "media/sub7-2-4.ee4dea8a.mp4";